export enum ChangeChartNameFormFields {
  NewChartName = 'newChartName',
}

export type TChangeChartNameForm = {
  [ChangeChartNameFormFields.NewChartName]: string;
};
